import { QUOTE_FLOW_SECTIONS } from 'common/constants';
import type { FC } from 'react';
import { useAppSelector } from 'store/hooks';
import QuoteStepper from './QuoteStepper';

const QuoteStepperWithContextWrapper: FC = () => {
  const { currentSection, currentStep } = useAppSelector('quoteStepper', [
    'currentSection',
    'currentStep',
  ]);

  return (
    <QuoteStepper
      currentSection={currentSection}
      currentStep={currentStep}
      sections={QUOTE_FLOW_SECTIONS}
    />
  );
};

export default QuoteStepperWithContextWrapper;
